import { Users, Sparkles, HeartHandshake, CheckCircle2, Compass } from "lucide-react";
import { Reveal } from "./Reveal";
import { site } from "../content/site";

const icons = { users: Users, spark: Sparkles, access: HeartHandshake };

export const Mission = () => (
  <section id="mission" data-testid="mission-section" className="py-20 lg:py-28 bg-slate-950 text-slate-100">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="max-w-3xl">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-teal-300 bg-teal-400/10 border border-teal-400/25 px-3 py-1.5 rounded-full inline-block">
          {site.mission.eyebrow}
        </p>
        <h2 className="mt-6 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">
          {site.mission.heading}
        </h2>
        <p className="mt-5 text-base sm:text-lg text-slate-400 leading-relaxed">{site.mission.intro}</p>
      </Reveal>

      <div className="mt-12 grid md:grid-cols-3 gap-5 lg:gap-6">
        {site.mission.pillars.map((pillar, i) => {
          const Icon = icons[pillar.icon];
          return (
            <Reveal key={pillar.title} delay={0.08 * i} className="h-full">
              <div
                data-testid={pillar.testId}
                className="h-full bg-white/[0.04] border border-white/10 rounded-2xl p-6 sm:p-7 transition-all duration-300 hover:border-teal-400/40 hover:bg-white/[0.07] hover:-translate-y-1"
              >
                <span className="w-11 h-11 rounded-xl bg-teal-400/10 border border-teal-400/25 text-teal-300 flex items-center justify-center">
                  <Icon size={20} strokeWidth={2} />
                </span>
                <h3 className="mt-5 font-display text-xl font-semibold tracking-tight text-white">{pillar.title}</h3>
                <p className="mt-2.5 text-sm text-slate-400 leading-relaxed">{pillar.text}</p>
              </div>
            </Reveal>
          );
        })}
      </div>

      <div className="mt-14 grid md:grid-cols-2 gap-5 lg:gap-6">
        {[
          { key: "now", data: site.mission.now, icon: CheckCircle2, testId: "mission-now-list" },
          { key: "next", data: site.mission.next, icon: Compass, testId: "mission-next-list" },
        ].map(({ key, data, icon: Icon, testId }, i) => (
          <Reveal key={key} delay={0.08 * i}>
            <div data-testid={testId} className="rounded-2xl border border-white/10 bg-gradient-to-b from-white/[0.05] to-transparent p-6 sm:p-8">
              <div className="flex items-center gap-3">
                <Icon size={18} className="text-teal-300" />
                <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-teal-300">{data.title}</h3>
              </div>
              <ul className="mt-5 space-y-3.5">
                {data.points.map((point) => (
                  <li key={point} className="flex gap-3 text-sm sm:text-base text-slate-300 leading-relaxed">
                    <span aria-hidden="true" className="mt-2 w-1.5 h-1.5 rounded-full bg-teal-400 shrink-0" />
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <p data-testid="mission-honesty-note" className="mt-10 text-sm text-slate-500 max-w-3xl leading-relaxed border-l-2 border-teal-400/40 pl-4">
          {site.mission.note}
        </p>
      </Reveal>
    </div>
  </section>
);
